<template>
  <global-modal
    :active.sync="settingSurat.showFormSignature"
    @toggleActive="toggleFormSignature"
  >
    <div class="w-full" slot="header">
      <div class="h4">Tambah Tanda Tangan</div>
    </div>
    <div class="w-full bg-white p-5 mb-20">
      <label for="">Pilih User</label>
      <vs-select
        :options="listPengguna"
        class="w-full"
        label="nama"
        v-model="pengguna"
      />
    </div>
    <div slot="footer" class="px-5 pb-5 w-full">
      <vs-button @click="addSignature" :disabled="loading">{{
        loading ? "Memuat" : "Simpan"
      }}</vs-button>
    </div>
  </global-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { digofHttp as axios } from "@/axios";

import { ALL } from "@/query/pengguna";

import vSelect from "vue-select";

export default {
  components: {
    "vs-select": vSelect
  },

  props: ["documentId"],

  data() {
    return {
      loading: false,
      listPengguna: [],
      pengguna: {}
    };
  },

  computed: {
    ...mapState({
      settingSurat: state => state.surat.settingSurat
    })
  },

  apollo: {
    listPengguna: {
      query: ALL,
      update: data => data.pengguna.data,
      variables() {
        return {
          // assume show all data in pagination
          perPage: 10000,
          where: { column : 'ID', value : 2 }
        };
      }
    }
  },

  methods: {
    async addSignature() {
      try {
        this.loading = true;
        const response = await axios({
          method: "get",
          url: `surat-keluar/get-sign-template/${this.pengguna.uuid}/${this.documentId}`,
          headers: {
            Authorization: `Bearer ${this.$sanctum.getToken()}`
          }
        });

        const userTemplate = response.data.data.url;
        const USER = {
          ...this.pengguna,
          template: userTemplate
        };

        this.$emit("callbackUsers", USER);
        this.toggleFormSignature(false);
        this.loading = false;
      } catch (e) {
        this.$vs.dialog({
          color: "danger",
          title: "Terjadi Kesalahan",
          text: "Silakan coba lagi atau hubungi TIM IT"
        });
      }
    },
    ...mapActions({
      toggleFormSignature: "surat/toggleFormSignature"
    })
  }
};
</script>
